export default function Roles() {
  const roles = [
    {
      title: 'مدير المشروع',
      description: 'الإشراف العام، التنسيق',
      icon: 'ri-user-star-line',
      color: 'from-[#1B5E20] to-[#2E7D32]',
      iconBg: 'bg-[#1B5E20]/10',
      iconColor: 'text-[#1B5E20]'
    },
    {
      title: 'فريق العمل',
      description: 'التنظيم، المحتوى، اللوجستيات',
      icon: 'ri-team-line',
      color: 'from-[#2E7D32] to-[#388E3C]',
      iconBg: 'bg-[#2E7D32]/10',
      iconColor: 'text-[#2E7D32]'
    },
    {
      title: 'المشاركون',
      description: 'المساهمة بالأفكار والتوصيات',
      icon: 'ri-lightbulb-line',
      color: 'from-[#388E3C] to-[#43A047]',
      iconBg: 'bg-[#388E3C]/10',
      iconColor: 'text-[#388E3C]'
    },
    {
      title: 'المستشارون',
      description: 'التحكيم العلمي',
      icon: 'ri-medal-line',
      color: 'from-[#43A047] to-[#4CAF50]',
      iconBg: 'bg-[#43A047]/10',
      iconColor: 'text-[#43A047]'
    },
    {
      title: 'المتطوعون',
      description: 'الدعم التنفيذي',
      icon: 'ri-hand-heart-line',
      color: 'from-[#4CAF50] to-[#66BB6A]',
      iconBg: 'bg-[#4CAF50]/10',
      iconColor: 'text-[#4CAF50]'
    }
  ];

  return (
    <section id="roles" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 bg-[#F5F5DC] px-6 py-3 rounded-full">
              <i className="ri-user-settings-line text-2xl text-[#1B5E20]"></i>
              <span className="text-sm font-bold text-[#1B5E20] tracking-wide">الأدوار والمسؤوليات</span>
            </div>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1B5E20] mb-6 leading-normal">
            فريق العمل والمشاركون
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            تعرف على الأدوار المختلفة في الملتقى ومسؤوليات كل فريق لضمان نجاح الفعالية وتحقيق أهدافها
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {roles.map((role, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#1B5E20]/20"
            >
              <div className="absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-300" 
                   style={{ backgroundImage: `linear-gradient(to bottom right, #1B5E20, #D4AF37)` }}></div>
              
              <div className="relative z-10">
                <div className={`w-16 h-16 ${role.iconBg} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${role.icon} text-3xl ${role.iconColor}`}></i>
                </div>

                <h3 className="text-2xl font-bold text-[#1B5E20] mb-4">
                  {role.title}
                </h3>

                <p className="text-base text-gray-600 leading-relaxed">
                  {role.description}
                </p>

                <div className="mt-6 pt-6 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-sm text-[#1B5E20] font-medium">
                    <span>دور أساسي</span>
                    <i className="ri-arrow-left-line text-lg group-hover:translate-x-[-4px] transition-transform"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-[#F5F5DC] to-white rounded-2xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-[#1B5E20] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-team-fill text-3xl text-white"></i>
            </div>
            <h4 className="text-3xl font-bold text-[#1B5E20] mb-3">5</h4>
            <p className="text-base text-gray-600 font-medium">أعضاء فريق أساسي</p>
          </div>

          <div className="bg-gradient-to-br from-[#F5F5DC] to-white rounded-2xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-user-star-fill text-3xl text-white"></i>
            </div>
            <h4 className="text-3xl font-bold text-[#1B5E20] mb-3">+10</h4>
            <p className="text-base text-gray-600 font-medium">خبير ومستشار</p>
          </div>

          <div className="bg-gradient-to-br from-[#F5F5DC] to-white rounded-2xl p-8 text-center shadow-lg">
            <div className="w-16 h-16 bg-[#2E7D32] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-hand-heart-fill text-3xl text-white"></i>
            </div>
            <h4 className="text-3xl font-bold text-[#1B5E20] mb-3">+20</h4>
            <p className="text-base text-gray-600 font-medium">متطوع داعم</p>
          </div>
        </div>
      </div>
    </section>
  );
}